const AdditionalDetails = ({ data }) => {
  return (
    <div className="lg:px-24 px-4 bg-gray-100 py-8 mt-2 lg:mt-8">
      <div className="mx-0 px-4 py-4 lg:py-12 bg-white rounded-md">
        <h2 className="text-2xl font-semibold">Thông tin chi tiết</h2>
        <p className="mt-2 lg:mt-8 text-[#9D9D9D]">{data.description}</p>
        <button className="mt-4 bg-accent-primaryColor text-white py-2 px-4 rounded-md">
          Xem thêm
        </button>
      </div>
    </div>
  );
};
export default AdditionalDetails;
